import { render } from "./SettingsIcon.vue?vue&type=template&id=6e259bac"
import script from "./SettingsIcon.vue?vue&type=script&lang=js"
export * from "./SettingsIcon.vue?vue&type=script&lang=js"
script.render = render

export default script